/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//================ PL Custom JS ================
jQuery(document).ready(function () {

  function size_change(lug_width, buckle_width) {
    lw = lug_width;
    if( lw < 16 || lw > 24){
      // Options: QRSB = Disabled
      jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Quick-Release Springbars"]').prop( "disabled", true );
      jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Quick-Release Springbars"]').prop( "checked", false );
      jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Quick-Release Springbars"]').parent("label").addClass("disable")
    } 
    else {
      // Options: QRSB = Not Disabled (Default)
      jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Quick-Release Springbars"]').prop( "disabled", false );
      jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Quick-Release Springbars"]').parent("label").removeClass("disable")
    }

    bw = buckle_width
    if( bw != 14 && bw != 16 && bw != 18 && bw != 20 && bw != "" && bw != 1 && bw != 2){
      // Options: Buckle Finish = Disabled
      jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Buckle Finish"]').prop( "disabled", true );
      jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Buckle Finish"]').prop( "checked", false );
      jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Buckle Finish"]').parent("label").addClass("disable")

      // Customize = Yes
      jQuery(".selector-wrapper[data-unique='_v8b0p3ntj'] input[value='Yes']").siblings('label').trigger("click")
    
      // Options: Custom Buckle = Automatically Checked
      if(!jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Custom Buckle"]:checked').val()){
          jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Custom Buckle"]').parent('label').trigger("click")
      }
    
    }
    else {
      // Options: Buckle Finish = Not Disabled (Default)
      jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Buckle Finish"]').prop( "disabled", false );
      jQuery('.selector-wrapper[data-unique=_yf0gn53ci] input[value="Buckle Finish"]').parent("label").removeClass("disable")
    }
  }
  
  // Custom Width: Lug Width
  jQuery("body").on("keyup", '.selector-wrapper[data-unique=_iws8zpkgz] input[type="number"]', function(){
     L = jQuery(this).val()
     B = jQuery('.selector-wrapper[data-unique=_f0ctpjcpv] input[type="number"]').val()

     size_change(L, B)
    jQuery(this).focus();
  })
  
  // Custom Width: Buckle Width
  jQuery("body").on("keyup", '.selector-wrapper[data-unique=_f0ctpjcpv] input[type="number"]', function(){
     B = jQuery(this).val()
     L = jQuery('.selector-wrapper[data-unique=_iws8zpkgz] input[type="number"]').val()

     size_change(L, B)
    jQuery(this).focus();
  })

// Remove Links from Menu Items
  jQuery(".HorizontalList__Item-Explore a.MegaMenu__Title").each(function(){
      jQuery(this).replaceWith("<p class='MegaMenu__Title Heading Text--subdued u-h7'>" + $( this ).text() + "</p>")
  })

  setInterval(function() {
    jQuery(".product_url").each((k,v)=>{
      let href=jQuery(v).attr("href")
      let title_href = jQuery(v).siblings(".ProductItem__Info").find('a').attr('href')
      if (href.indexOf('/', 1) === 12) {
        href = href.slice(href.indexOf("/", 1))
        href = href.slice(href.indexOf("/", 1))
        jQuery(v).attr("href",href)
      }
      if (title_href.indexOf('/', 1) === 12) {
        title_href = title_href.slice(title_href.indexOf("/", 1))
        title_href = title_href.slice(title_href.indexOf("/", 1))
        jQuery(v).siblings(".ProductItem__Info").find('a').attr('href', title_href)
      }
      
    })
  }, 1000);

  if(jQuery(".bcpo-price-addons").length > 0){
    setInterval(function () {
      jQuery(".bcpo-price-addons").html(jQuery(".bcpo-price-addons").html().replace("Selection will add","Customization adds"))
      jQuery(".bcpo-price-addons").html(jQuery(".bcpo-price-addons").html().replace("to the price","to the product price."))
    }, 1000);
  }
  
}) //End Document
